import { EmployeeTier } from '@/types/schema';

export const EMPLOYEE_TIER_DISPLAY_MAP: Record<EmployeeTier, string> = {
  [EmployeeTier.Advanced]: 'Advanced',
  [EmployeeTier.Basic]: 'Basic',
  [EmployeeTier.ViewOnly]: 'Limited',
};
